import { LanguageSystem } from '../../models/language.system';
import { TranslateService } from '@ngx-translate/core';
import { StoragePermissionService } from '../../services/storagePermission/storage-permission.service';
import { environment } from '../../../environments/environment';
import { DomainsModel } from '../../models/domains.model';

export class Language {
  static currentLanguage: LanguageSystem = environment.multisite.defaultLang;
  dataSourceLenguajeId: LanguageSystem[] = environment.multisite.langs;

  codigolenguajeActual() {
    return Language.currentLanguage.lenid;
  }

  nombrelenguajeActual() {
    return Language.currentLanguage.lennombre;
  }

  cambiarLenguaje(lenguaje: LanguageSystem, translate: TranslateService, poseeLenguaje: Boolean, stogareService: StoragePermissionService) {
    const found = this.dataSourceLenguajeId.find(function (element) {
      return element.lenid === lenguaje.lenid;
    });
    let initLang = translate.getBrowserLang();
    if (found !== undefined && found !== null) {
      const defaultLanguage = lenguaje.lenid.toString();
      const additionalLanguages = [];
      const languages: string[] = [defaultLanguage].concat(additionalLanguages);
      translate.setDefaultLang(defaultLanguage);
      translate.addLangs(additionalLanguages);
      if (!poseeLenguaje) {
        if (languages.indexOf(initLang) === -1) {
          initLang = defaultLanguage;
        }
      } else {
        initLang = lenguaje.lenid.toString();
      }
      lenguaje.lenid = initLang;

      if (lenguaje.lennombre === undefined || lenguaje.lennombre === '') {
        lenguaje.lennombre = found.lennombre;
      }
    } else {
      lenguaje = this.dataSourceLenguajeId[0];
      initLang = lenguaje.lenid.toString();
    }

    translate.use(initLang);
    Language.currentLanguage = lenguaje;
    stogareService.setStorage('LenguajeActual', JSON.stringify(lenguaje));
  }

  inicializarLenguaje(translate: TranslateService, stogareService: StoragePermissionService, domain: DomainsModel) {
    let ISOLanguage = domain.language == 'default' ? translate.getBrowserLang() : domain.ISOLanguage;
    var lenguaje: LanguageSystem = { lenid: ISOLanguage, lennombre: 'default' };
    this.cambiarLenguaje(lenguaje, translate, false, stogareService);
  }
}
